export default __webpack_public_path__ + "static/media/piano-without-melody-short-loop-60-bpm.4eef14ed.mp3";